import React from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';

interface BottomBarProps {
  onEndCall: () => void;
}

export const BottomBar: React.FC<BottomBarProps> = ({ onEndCall }) => {
  const styles = StyleSheet.create({
    bottomBar: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      width: '100%',
      height: 66,
      backgroundColor: '#000',
      borderTopWidth: 1,
      borderTopColor: 'rgba(255, 255, 255, 0.1)',
      borderTopStyle: 'solid',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      '@media (max-width: 768px)': {
        height: 56,
      },
    },
    actionButtons: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 16,
      width: '100%',
      maxWidth: 800,
      paddingLeft: 16,
      paddingRight: 16,
      '@media (max-width: 768px)': {
        gap: 12,
        paddingLeft: 12,
        paddingRight: 12,
      },
    },
    actionButton: {
      width: 50,
      height: 50,
      borderRadius: 25,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      borderWidth: 1,
      borderColor: 'rgba(255, 255, 255, 0.2)',
    },
    endCallButton: {
      backgroundColor: '#FF3B30',
      borderWidth: 0,
    },
  });

  return (
    <View style={styles.bottomBar}>
      <View style={styles.actionButtons}>
        <TouchableOpacity style={styles.actionButton}>
          <MaterialIcons name="mic" size={28} color="#fff" />
        </TouchableOpacity>
        <TouchableOpacity 
          style={[styles.actionButton, styles.endCallButton]} 
          onPress={onEndCall}
        >
          <MaterialIcons name="call-end" size={28} color="#fff" />
        </TouchableOpacity>
        <TouchableOpacity style={styles.actionButton}>
          <MaterialIcons name="volume-up" size={28} color="#fff" />
        </TouchableOpacity>
      </View>
    </View>
  );
};
